// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__38mza","search":"Settings_search__9idWk","filter":"Settings_filter__2oSGz"};